const checkFullscreen = (): boolean => {
  return (
    window.outerHeight === window.screen.height &&
    window.outerWidth === window.screen.width
  );
};

export default checkFullscreen;
